export default "__VITE_ASSET__BrpMcCP1__";